var is_mobile = window.matchMedia('all and (max-width: 600px)').matches;
var is_tablet = window.matchMedia('all and (max-width: 1100px)').matches;

if (typeof BX !== 'undefined' && BX !== null) {
	BX.showWait = function () {
		var loader = `
			<div class="preloader">
				<div class="preloader-block">
					<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg init preloader-ico">
						<g clip-path="url(#clip0_9929_82189)">
							<g clip-path="url(#clip1_9929_82189)">
								<path d="M30.0005 6.00885V7.4227H22.5117V6.09722L26.0992 4.10899C26.5924 3.8439 26.9512 3.62298 27.1754 3.44625C27.3996 3.26952 27.579 3.13697 27.6687 3.00443C27.7583 2.87188 27.8032 2.69515 27.8032 2.51842V2.43005C27.8032 2.12077 27.6687 1.85567 27.3548 1.67894C27.0409 1.50221 26.6373 1.41385 26.0543 1.41385C25.4714 1.41385 25.0229 1.50221 24.709 1.72313C24.3951 1.89986 24.2606 2.20914 24.2606 2.60678V2.8277H22.5566V2.60678C22.5566 1.76731 22.8705 1.10457 23.4534 0.662741C24.0364 0.220914 24.8884 0 26.0095 0C27.1305 0 27.9826 0.220914 28.5655 0.618559C29.1933 1.06039 29.5072 1.63476 29.5072 2.38587V2.51842C29.5072 2.87188 29.4175 3.22534 29.283 3.49044C29.1485 3.79972 28.8794 4.06481 28.5207 4.37409C28.1619 4.68337 27.6687 4.99265 26.996 5.34611L25.6507 6.09722H30.0005V6.00885Z" fill="#171717"/>
							</g>
							<g clip-path="url(#clip2_9929_82189)">
								<path d="M22.5594 10.207V10.6489L16.7747 23.2409H13.2769L7.49219 10.6489V10.207H10.5864L15.0258 20.3249L19.4653 10.207H22.5594Z" fill="#171717"/>
							</g>
							<path d="M19.5 1H1V28.5H29V10" stroke="#F5333F" stroke-width="2" class="preloader-line"/>
						</g>
						<defs>
							<clipPath id="clip0_9929_82189">
								<rect width="30.0005" height="30.0011" fill="white"/>
							</clipPath>
							<clipPath id="clip1_9929_82189">
								<rect width="7.48878" height="7.4227" fill="white" transform="translate(22.5117)"/>
							</clipPath>
							<clipPath id="clip2_9929_82189">
								<rect width="15.0672" height="13.0339" fill="white" transform="translate(7.49219 10.207)"/>
							</clipPath>
						</defs>
					</svg>

				</div>
			</div>`;

		$('body').append(loader);

		fromTo('.preloader', {
			opacity: 0
		}, {
			opacity: 1,
			duration: .3,
		})
	};

	BX.closeWait = function () {
		to('.preloader', {
			opacity: 0,
			duration: .3,
			onComplete: () => {
				$('body').find('.preloader').remove();
			}
		})
	};
}

$(function () {
	$.fancybox.defaults.hash = false;
	$.fancybox.defaults.animationEffect = "fade";
	$.fancybox.defaults.loop = true;

	check_expand_text();

	$(window).on('resize', function () {
		is_mobile = window.matchMedia('all and (max-width: 600px)').matches;
		is_tablet = window.matchMedia('all and (max-width: 1100px)').matches;
	});

	$(document).on('click', '.js-close-modal', (e) => {
		let self = $(e.currentTarget)

		e.preventDefault()

		self.closest('.modal').removeClass("active");
		$('html').removeClass("no-scroll");
	});

	$(document).on('click', '.js-open-modal-out-stock', (e) => {
		let self = $(e.currentTarget),
			product_id = self.attr('data-product-id'),
			modal = $('#modal-out-stock')

		modal.find('[name="product-id"]').val(product_id)
	})

	$(document).on('click', '.js-open-modal', (e) => {
		let self = $(e.currentTarget),
			id = self.attr('href')

		open_modal(id);

		e.preventDefault()
	});

	$(document).on('click', '.js-anchor', (e) => {
		let self = $(e.currentTarget),
			target = $(self.attr('href')),
			offset = $('.header').height(),
			top = target.offset().top

		if ($('.catalog-nav').length > 0) {
			offset += $('.catalog-nav').height();
		}

		$('body,html').animate({scrollTop: top - offset}, 600)
	});

	$(document).on('click', '.show-more-btn', (e) => {
		let block = $(e.currentTarget).closest(".show-more-block"),
			text = block.find(".show-more-text"),
			tl = gsap.timeline(),
			height = 15;

		if (!block.hasClass('has-expand')) return;

		block.toggleClass('show');

		if (block.hasClass('show')) {
			to(text, {height: "auto", duration: .6, ease: "easeTextCollapse"}, tl);
		} else {
			to(text, {height: height + 'rem', duration: .6, ease: "easeTextCollapse"}, tl);
		}
	});

	$('.js-close-modal-mobile').on('click', (e) => {
		$('.modal-mobile').removeClass("active");
	});

	$('.js-open-modal-mobile').on('click', (e) => {
		let self = $(e.currentTarget),
			id = self.attr('href')

		$(id).addClass("active");
	});

	$('.js-tab-nav').on('click', (e) => {
		let self = $(e.currentTarget),
			block = self.closest('.js-tab'),
			content = block.find('.js-tab-content'),
			nav = block.find('.js-tab-nav'),
			index = self.index(),
			content_active = content.eq(index)


		nav.removeClass('active');
		self.addClass("active");

		content.removeClass('active');
		content.eq(index).addClass("active");

		fromTo(content_active, {opacity: '0'}, {opacity: "1", duration: .6, ease: "easeTextCollapse"}, gsap.timeline());
		fromTo(content.not(content_active), {opacity: "1"}, {
			opacity: '0',
			duration: .6,
			ease: "easeTextCollapse"
		}, gsap.timeline());

	});

	$(document).on('click', '.tr-click', (e) => {
		let self = $(e.currentTarget),
			href = self.attr('data-href')

		window.location.href = href;
	})

	if (getCookie('cookie-popup') !== "1") {
		setTimeout(function () {
			$('.cookie-popup').addClass("show")
		}, 3000)
	}

	$('.js-close-cookie-popup').on('click', (e) => {
		$('.cookie-popup').removeClass("show")
		setCookie("cookie-popup", 1);
	})

	$('.js-close-popup-auth').on('click', (e) => {
		$('.popup-auth').removeClass("show")
	})

	/**
	 * Блок Показать/скрыть
	 */
	$(document).on('click', '.js-show-more-btn', function () {
		const $block = $(this).closest(".js-show-more-block"),
			tl = gsap.timeline();
		const $content = $block.find(".js-show-more-content");
		const height = $content.attr('data-height') ?? 150;

		$block.toggleClass('_show');

		if ($block.hasClass('_show')) {
			to($content, {height: "auto", duration: .6, ease: "easeTextCollapse"}, tl);
		} else {
			to($content, {height: `${height}px`, duration: .6, ease: "easeTextCollapse"}, tl);
		}
	});

	$(document).on('mouseenter', '.js-cart-preview', function () {
		if($(this).hasClass('_empty')) return;
		if(window.innerWidth < 767.98) return;
		$('body').addClass('_shadow');
	});
	$(document).on('mouseleave', '.js-cart-preview', function () {
		$('body').removeClass('_shadow');
	});
});

const showPopupAuthMessage = () => {
	$('.popup-auth').addClass("show")
}


const check_expand_text = () => {
	$('.show-more-text').each((k, itm) => {
		let height = 15;

		if ($(itm).closest('#catalog-char').length > 0) {
			height = 21;
		}
		if ($(itm).closest('#catalog-desc').length > 0) {
			height = 10;
		}

		$(itm).css('height', height + 'rem');
		const text = $(itm).find('.show-more-text__content');

		if (text.innerHeight() > $(itm).innerHeight()) {
			$(itm).closest(".show-more-block").addClass("has-expand");
		} else {
			$(itm).closest(".show-more-block").removeClass("has-expand");
			$(itm).css('height', 'auto');
		}
	});

	$(document).on('click', '.js-accordion-head', (e) => {
		let self = $(e.currentTarget),
			self_accordion = self.parent()

		/*$('.js-accordion').not(self_accordion).removeClass("active");
		$('.js-accordion').not(self_accordion).find('.js-accordion-body').slideUp();*/

		self_accordion.toggleClass('active')
		self.siblings('.js-accordion-body').slideToggle();
	});
}

const open_modal = (id) => {
	$(id).addClass("active");
	$('html').addClass("no-scroll");
}
const close_modal = (id) => {
	$(id).removeClass("active");
}

const close_all_modal = () => {
	$('.modal').removeClass("active");
	$('html').removeClass("no-scroll");
}

const setCookie = (name, value, days = 30, path = "/") => {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=" + path;
}
const getCookie = (name) => {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

const to = (itm, option, module = gsap.timeline(), timing = ">") => {
	if (!itm || itm.length === 0) return


	module.to(itm, option, timing)
}
const fromTo = (itm, optionFrom, optionTo, module = gsap.timeline(), timing = ">") => {
	if (!itm || itm.length === 0) return

	module.fromTo(itm, optionFrom, optionTo, timing);
}